<svg attr.width="{{width}}px" attr.height="{{height}}px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2596_21323)">
        <path d="M18.3333 6.2793V14.1668C18.3334 14.8045 18.0897 15.4181 17.6523 15.882C17.2148 16.346 16.6166 16.6252 15.98 16.6626L15.8333 16.6668H4.16666C3.52899 16.6668 2.9154 16.4232 2.45145 15.9857C1.98749 15.5483 1.70824 14.95 1.67083 14.3135L1.66666 14.1668V6.2793L9.5375 11.5268L9.63416 11.5818C9.74808 11.6375 9.8732 11.6664 10 11.6664C10.1268 11.6664 10.2519 11.6375 10.3658 11.5818L10.4625 11.5268L18.3333 6.2793Z"
              attr.fill="{{color}}"/>
        <path d="M15.8333 3.3335C16.7333 3.3335 17.5225 3.8085 17.9625 4.52266L10 9.831L2.0375 4.52266C2.24644 4.1833 2.53351 3.89883 2.87475 3.69298C3.216 3.48713 3.60153 3.36588 3.99917 3.33933L4.16667 3.3335H15.8333Z"
              attr.fill="{{color}}"/>
    </g>
    <defs>
        <clipPath id="clip0_2596_21323">
            <rect attr.width="{{width}}px" attr.height="{{height}}px" attr.fill="{{color}}"/>
        </clipPath>
    </defs>
</svg>
